<app-field
  [focused]="focused"
  [dirty]="!empty"
  [disabled]="disabled"
  [showErrorEnabled]="!!showErrorEnabled"
>
  <input
    field
    #inputEl
    [formControl]="formControl"
    [name]="name ?? ''"
    type="color"
    [readonly]="!!readOnly"
    (focus)="onFocusChanged(true)"
    (blur)="onFocusChanged(false)"
    (input)="onInputValue($event)"
  />

  <app-button
    appFieldSuffix
    *ngIf="showClearButton && !!value"
    buttonType="normal"
    styleType="text"
    shapeType="circle"
    sizeType="x-small"
    icon="assets/icons/xmark.svg"
    (click)="onBtnClearClick($event)"
  ></app-button>

  <ng-container appFieldSuffix>
    <ng-content select="[appFieldSuffix]"></ng-content>
  </ng-container>
</app-field>
